//
//
//
//
//
//
//
//
//
//
//
import GlobalLayout from '@/components/page/GlobalLayout';
export default {
  name: "BasicLayout",
  components: {
    GlobalLayout: GlobalLayout
  },
  data: function data() {
    return {};
  },
  computed: {
    keepAlive: function keepAlive() {
      return this.$route.meta.keepAlive;
    }
  },
  methods: {}
};